import { render, staticRenderFns } from "./SeveranceWizard.vue?vue&type=template&id=2e1b34d6"
import script from "./SeveranceWizard.vue?vue&type=script&lang=js"
export * from "./SeveranceWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports